import AbstractField from "./AbstractField";

export default class SelectionOverview extends AbstractField {
    setElement(element) {
        this.hide();
    }

    make() {
        this.field = this.p.createDiv()
            .style('margin-top', '15px');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.initialized = true;
        return this;
    }

    update() {
        this.field.html('');
        this.selection.items.map((item) => {
            let name = item.labels.hasLabels() ? `${item.name} (${item.title})` : item.title;
            this.p.createDiv(name).parent(this.field)
                .mouseOver(() => this.hoverSet.add(item))
                .mouseOut(() => this.hoverSet.remove(item))
                .mouseClicked(() => {
                    this.hoverSet.remove(item);
                    this.selection.remove(item);
                });
        });
    }

    reset() {
        this.field.html('');
    }
}
